import { useEffect, useState } from 'react';

export const useOnCookieChange: () => string | null = () => {
  const [cookie, setCookie] = useState<string | null>(null);

  const getCookie: () => void = () => {
    if(typeof document != 'undefined') {
      const latestCookie = document.cookie
      if (latestCookie !== null && latestCookie !== '') {
        document.cookie?.split(';')
            ?.find((cki) => cki.includes('OptanonConsent'))
            ?.replace(' OptanonConsent=', '');

        if (latestCookie !== cookie) setCookie(latestCookie);
      }
    }
  };

  useEffect(() => {
    getCookie();
  }, []);

  setInterval(() => {
    getCookie();
  }, 1000);

  return cookie;
};
